import { Suspense, lazy, useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router";
import GuardedRoute from "./components/guardedRoute/GuardedRoute";
import { appRoutes } from "../routes";
import { RoutesContext } from "./contexts/routes.context";
import moment from "moment";
import "moment/locale/sv";
import "moment/locale/en-au";
import Cookies from 'js-cookie';
import { useTranslation } from "react-i18next";
import { UserRole } from "./models/dto/users/user.dto";
import useBrowserBackStack from "./hooks/browserBackStack";
import { BrowserHistoryContext } from "./contexts/browserHistory.context";
import useRequiredParam from "./hooks/urlParamHook";

const DashboardComponent = lazy(() => import("./dashboard/DashboardComponent"));
const PagesComponent = lazy(() => import("./pages/PagesComponent"));

const AppComponent = () => {
    const [routes, setRoutes] = useState(appRoutes);
    const { t, i18n } = useTranslation();
    const backStack = useBrowserBackStack();
    const baseRouteUrl = ":locale?";
    const params = useParams();
    const locale = params.locale;
    if (!locale) {
        const { pathname, search } = window.location;
        window.location.href =
            pathname === "/undefined"
                ? `/sv${search}`
                : `/sv${pathname}${search}`;
    }
    moment.locale(locale == "en" ? "en-au" : locale);
    var faq_slug = 'vanliga-fragor-2';
    var about_slug = 'om-bookabus-se';
    var contact_slug = 'kontakta-oss';
    if (i18n.language == 'en') {
        faq_slug = 'faq';
        about_slug = 'about';
        contact_slug = 'contact-us';
    }
    const updateRoutesByLanguage = (language: string) => {
        let newRoutes: any = {}
        Object.keys(routes).forEach((key) => {
            if (typeof routes[key] == "object") {
                newRoutes[key] = updateRouteProperties(routes[key], language);
            }
            else {
                newRoutes[key] = "/" + language + routes[key];
            }
        });
        setRoutes(newRoutes);
    }

    const updateRouteProperties = (routeObject: any, language: string, routePrefix: string = ""): any => {
        const properties = Object.keys(routeObject);
        const newRoutes: any = {};

        properties.forEach((key) => {
            const value = routeObject[key];
            if (typeof value === "object" && value !== null) {
                // Recursively pass the updated routePrefix if any
                if (value["path"] && value["path"].toString().includes("/*")) {
                    routePrefix += value["path"].replace("*", "");
                }
                newRoutes[key] = updateRouteProperties(value, language, routePrefix);
            } else {
                const segments = value.toString().split("/");
                const pathParam = segments.find((c: string) => c.startsWith(":"));
                // Remove the param if it exists
                const cleanedPath = pathParam ? value.toString().replace(pathParam, "") : value;
                newRoutes[key] = "/" + language + routePrefix + cleanedPath;
                // Update routePrefix if it contains a wildcard

            }
        });

        return newRoutes;
    };


    useEffect(() => {
        if (locale) {
            i18n.changeLanguage(locale);
            updateRoutesByLanguage(locale);
        }
    }, [])
    // @ts-ignore
    return <>
        {<RoutesContext.Provider value={{ routes: routes, setLanguage: (language: string) => { updateRoutesByLanguage(language) } }}>
            <BrowserHistoryContext.Provider value={{ backStack: backStack as any }}>
                <Suspense fallback={<div></div>}>

                    <Routes>
                        <Route
                            path={baseRouteUrl + appRoutes.dashboard.main.path}
                            element={
                                <GuardedRoute>
                                    <DashboardComponent />
                                </GuardedRoute>
                            }
                        />
                        <Route
                            path="/*"
                            element={
                                <GuardedRoute
                                    notAllowedRoles={[
                                        { name: UserRole.SystemAdmin, redirectRoute: routes.dashboard.admin.main.path },
                                        { name: UserRole.SystemOwner, redirectRoute: routes.dashboard.admin.main.path },
                                        { name: UserRole.CompanyAdmin, redirectRoute: routes.dashboard.company.main.path },
                                        { name: UserRole.DealCustomerFinance, redirectRoute: routes.dashboard.dealOrg.main.path },
                                    ]}
                                    noAuthNeeded={true}
                                >
                                    <PagesComponent />
                                </GuardedRoute>
                            }
                        />
                    </Routes>
                </Suspense>
            </BrowserHistoryContext.Provider>

        </RoutesContext.Provider>}

    </>

}
export default AppComponent;